import React from "react";
import { useWindowSize } from "react-use";
import Confetti from "react-confetti";

import { useSidebarLayoutContext } from "contexts/SidebarLayoutContext";

import confettiSound from "assets/audio/confetti.mp3";

const AppConfetti = ({ numberOfPieces = 500 }) => {
  const { width, height } = useWindowSize();

  const { party, setParty } = useSidebarLayoutContext();

  React.useEffect(() => {
    if (!party) return;

    const _confettiAudio = new Audio(confettiSound);
    _confettiAudio.play();

    return () => {
      _confettiAudio.pause();
      _confettiAudio.currentTime = 0;
      setParty(false);
    };
  }, [party, setParty]);

  return (
    <Confetti
      width={width - 20}
      height={height}
      recycle={false}
      numberOfPieces={party ? numberOfPieces : 0}
      onConfettiComplete={(confetti) => {
        confetti.reset();
        setParty(false);
      }}
    />
  );
};

export default AppConfetti;
